<template>
  <div>
    <v-row justify="center" align="center">
      <v-col cols="12" md="12" sm="12">
        <v-banner icon="mdi-card-search-outline">
          Your Orders
          <template v-slot:actions>
            <v-btn text color="blue darken-2" exact @click="$router.go(-1)">
              <v-icon left>arrow_back</v-icon>Back
            </v-btn>
          </template>
        </v-banner>
        <v-toolbar color="background" flat>
          <v-toolbar-title class="subtitle-2 font-weight-medium"
            >Distributor :
            {{ ticket ? ticket.distributor_name : "" }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-toolbar-title class="subtitle-2 font-weight-medium"
            >Invoice No : {{ invoiceNo }}</v-toolbar-title
          >
        </v-toolbar>

        <v-data-table
          :headers="headers"
          :items="orderProducts"
          hide-default-footer
          disable-pagination
          class="elevation-0"
        >
          <template v-slot:item.qty="{ item }">
            <span>{{ parseFloat(item.quantity_ordered).toFixed(0) }}</span>
          </template>
          <template v-slot:item.price="{ item }">
            <span>
              <span class="font-weight-medium"
                >£ {{ parseFloat(item.item_price).toFixed(2) }}</span
              >
            </span>
          </template>
          <template v-slot:item.value="{ item }">
            <span>
              <span class="font-weight-medium">
                £
                {{
                  parseFloat(
                    parseFloat(item.item_value) + parseFloat(item.vat_value)
                  ).toFixed(2)
                }}
              </span>
            </span>
          </template>

          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.product_no }}</td>
              <td>{{ item.prod_desc }}</td>
              <td>{{ item.variety }}</td>
              <td>{{ item.size }}</td>
              <td>{{ item.quantity_type }}</td>
              <td>{{ parseFloat(item.quantity_ordered).toFixed(0) }}</td>
              <td>
                <span class="font-weight-medium">
                  £ {{ parseFloat(item.item_price).toFixed(2) }}
                </span>
              </td>
              <td>
                <span>
                  <span class="font-weight-medium">
                    £
                    {{
                      parseFloat(
                        parseFloat(item.item_value) + parseFloat(item.vat_value)
                      ).toFixed(2)
                    }}
                  </span>
                </span>
              </td>
            </tr>
            <tr
              v-for="credit in item.credits"
              :key="credit.id"
              style="background-color: var(--v-background_off-base)"
              class="red--text text--darken-1"
            >
              <td>Credit No: # {{ credit.credit_invoice_no }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>{{ parseFloat(credit.quantity).toFixed(0) }}</td>
              <td></td>
              <td>
                <span class="font-weight-medium">
                  £
                  {{
                    parseFloat(
                      parseFloat(credit.item_value) +
                        parseFloat(credit.vat_value)
                    ).toFixed(2)
                  }}
                </span>
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-card color="background" flat>
          <v-card-title class="subtitle-2 justify-center"
            >Invoice Summary</v-card-title
          >
          <v-list-item two-line>
            <v-row>
              <v-col cols="6" sm="3" md="3" lg="2">
                <v-list-item-content>
                  <v-list-item-title class="subtitle-2 font-weight-medium"
                    >Total Packages</v-list-item-title
                  >
                  <v-list-item-subtitle v-if="retrieveInvoiceSummary">{{
                    retrieveInvoiceSummary.totalPackages
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <v-col cols="6" sm="3" md="3" lg="2">
                <v-list-item-content>
                  <v-list-item-title class="subtitle-2 font-weight-medium"
                    >Total Boxes</v-list-item-title
                  >
                  <v-list-item-subtitle v-if="retrieveInvoiceSummary">{{
                    retrieveInvoiceSummary.totalBox
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <v-col cols="6" sm="3" md="3" lg="2">
                <v-list-item-content>
                  <v-list-item-title class="subtitle-2 font-weight-medium"
                    >Total Kilo</v-list-item-title
                  >
                  <v-list-item-subtitle v-if="retrieveInvoiceSummary">{{
                    retrieveInvoiceSummary.totalKilos
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <v-col cols="6" sm="3" md="3" lg="2">
                <v-list-item-content>
                  <v-list-item-title class="subtitle-2 font-weight-medium"
                    >Total Each</v-list-item-title
                  >
                  <v-list-item-subtitle v-if="retrieveInvoiceSummary">{{
                    retrieveInvoiceSummary.totalEach
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <v-col cols="6" sm="3" md="3" lg="2">
                <v-list-item-content>
                  <v-list-item-title class="subtitle-2 font-weight-medium"
                    >Total Value</v-list-item-title
                  >
                  <v-list-item-subtitle v-if="retrieveInvoiceSummary"
                    >£
                    {{
                      parseFloat(retrieveInvoiceSummary.totalValue).toFixed(2)
                    }}</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-col>
            </v-row>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>

    <!-- <OrderTimeline :ticket="ticket" /> -->
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

// import OrderTimeline from "@/components/order/OrderTimeline.vue";

export default {
  name: "TicketDetails",

  components: {
    // OrderTimeline,
  },

  data: () => {
    return {
      headers: [
        { text: "Product", value: "product_no", sortable: false },
        { text: "Description", value: "prod_desc", sortable: false },
        { text: "Variety", value: "variety", sortable: false },
        { text: "Size", value: "size", sortable: false },
        { text: "Type", value: "quantity_type", sortable: false },
        { text: "Qty", value: "qty", sortable: false },
        { text: "Price", value: "price", sortable: false },
        { text: "Value", value: "value", sortable: false },
      ],

      totalEach: 0,
    };
  },
  computed: {
    ...mapGetters(["retrieveAllOrders", "retrieveInvoiceSummary"]),
    orderProducts() {
      return this.$store.state.ordersHistory.orderProducts;
    },

    invoiceNo() {
      return this.$route.params.invoice_no;
    },
    ticket() {
      return this.$route.params.ticket;
    },
  },
  methods: {
    ...mapActions(["fetchOrdersProducts"]),
  },
  created() {},
  beforeDestroy() {},
};
</script>